
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftBottom50 as ObiThreewayStackedInleftBottom50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-bottom-50.js';
 
 
 

 
 export const ObiThreewayStackedInleftBottom50 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-bottom-50',
   elementClass: ObiThreewayStackedInleftBottom50Element,
   events: {
     
   }
  });
 
 